/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { If, Then, Else } from "react-if";
import { Link } from "react-router-dom";
import { CSSProperties } from "styled-components";
import { FlexContainer } from "@nordcloud/gnui";

type Props = {
  name: string;
  link?: string;
  containerStyle?: CSSProperties;
};

export function NameWithLink({ name, link, containerStyle = {} }: Props) {
  return (
    <FlexContainer
      justifyContent="center"
      alignItems="flex-start"
      direction="column"
      style={containerStyle}
    >
      <If condition={link}>
        <Then>
          <Link to={link ?? ""}>{name}</Link>
        </Then>
        <Else>
          <div>{name}</div>
        </Else>
      </If>
    </FlexContainer>
  );
}
